import { ErrorMessage, Field, useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../utils/constant';

export const StyledInput = styled.input`
  border-radius: 2px;
  border: 1.4px solid ${Colors.White};
  padding: 16px;
  width: 100%;
  height: 58px;
  font-weight: 700;
  font-size: 16px;
  line-height: 160%; /* 25.6px */
  letter-spacing: 0.64px;
  color: ${Colors.White};
  //opacity: 0.6;
  background-color: transparent;
  &:focus {
    outline: none;
    opacity: 1;
  }
  &::placeholder {
    color: ${Colors.White};
    opacity: 0.6;
  }
`;

const ErrorText = styled.p`
  color: ${Colors.red};
  font-size: 14px;
  text-align: left;
  margin-top: 2px;
`;

const StyledSpan = styled.span`
  color: ${Colors.CoralPink};
  font-size: 14px;
  margin-bottom: 8px;
  margin-left: 4px;
`;

const StyledLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledHint = styled.p`
  color: ${Colors.CoralPink};
  font-size: 14px;
  text-align: left;
  font-weight: 400;
  margin-top: 2px;
`;

const StyledLabel = styled.p<{
  labelColor: string;
  disabled: boolean;
}>`
  font-size: 16px;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: 0.64px;
  margin-bottom: 8px;
  text-align: left;
  color: ${({ labelColor }) => labelColor};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

interface Props {
  label?: string;
  name: string;
  type?: string;
  required?: boolean;
  markAsRequired?: boolean;
  placeholder?: string;
  hint?: string;
  disabled?: boolean;
  labelColor?: string;
}

export default function TextInputField(props: Props) {
  const {
    label,
    name,
    type = 'text',
    required = false,
    markAsRequired = false,
    placeholder = '',
    hint = '',
    disabled = false,
    labelColor = Colors.White,
  } = props;
  const renderError = (message: string) => <ErrorText>{message}</ErrorText>;
  const { errors } = useFormikContext();
  // @ts-ignore
  const hasError = errors[name];

  return (
    <>
      {label && (
        <StyledLabelContainer>
          <StyledLabel labelColor={labelColor} disabled={disabled}>
            {label}
          </StyledLabel>
          {!disabled && markAsRequired && <StyledSpan>*</StyledSpan>}
        </StyledLabelContainer>
      )}
      <Field
        as={StyledInput}
        placeholder={placeholder}
        type={type}
        required={required}
        name={name}
        disabled={disabled}
      />
      {hint && !hasError && <StyledHint>{hint}</StyledHint>}
      <ErrorMessage name={name} render={renderError} />
    </>
  );
}
